import { useState } from "react";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Checkbox } from "@nextui-org/react";
import { MdOutlineEmail } from "react-icons/md";

import { useLogin } from "../hooks/useLogin";

import AuthLayout from "@/layouts/Auth/AuthLayout";

import Input from "@/components/input/Input";
import Button from "@/components/Button";
import { RiLockPasswordLine } from "react-icons/ri";

function LoginForm() {
    const [remember, setRemember] = useState(false);
    const { login, isPending } = useLogin();
    const {
        register,
        formState: { errors },
        reset,
        handleSubmit,
    } = useForm();

    function onSubmit(data) {
        const { email, password } = data;
        if (!email && !password) return;

        login(
            { email, password, remember },
            {
                onSuccess: () => {
                    reset();
                },
            }
        );
    }

    return (
        <AuthLayout
            image="bg-login"
            title="تسجيل الدخول"
            description="ادخل علي حسابك بإدخال البريد الألكتروني و كلمة المرور المسجل بهم من قبل"
            className="py-7"
        >
            <form
                onSubmit={handleSubmit(onSubmit)}
                className="flex flex-col justify-center w-2/3 gap-2 md:w-4/6"
            >
                {/* Email */}
                <div>
                    <Input
                        className="py-2"
                        type="email"
                        name="email"
                        id="email"
                        disable={"false"}
                        label="البريد الإلكتروني*"
                        icon={MdOutlineEmail}
                        register={register("email", {
                            required: "هذه الخانة مطلوبه",
                            pattern: {
                                value: /\S+@\S+\.\S+/,
                                message: "يرجى كتابة عنوان بريد إلكتروني صالح",
                            },
                        })}
                        error={errors?.email?.message}
                    />
                </div>
                <div>
                    <Input
                        className="py-2"
                        type="password"
                        label="كلمة السر"
                        name="password"
                        error={errors?.password?.message}
                        icon={RiLockPasswordLine}
                        register={register("password", {
                            required: "هذه الخانة مطلوبه",
                        })}
                    />
                </div>
                {/* Password */}
                <div className="flex items-center justify-between">
                    <Checkbox
                        color="primary"
                        className="py-3"
                        onChange={() => setRemember((remember) => !remember)}
                    >
                        <span className="px-3 text-blue-color-primary">
                            تذكرني
                        </span>
                    </Checkbox>

                    <Link
                        to="/auth/forgetpassword"
                        className="px-2 text-mint-green-color-primary"
                    >
                        هل نسيت كلمة السر؟
                    </Link>
                </div>

                <div className="w-full py-3">
                    <Button
                        type="primary"
                        disabled={isPending}
                        className="w-full leading-7"
                    >
                        {!isPending ? "تسجيل" : "...جاري التسجيل"}
                    </Button>
                </div>
            </form>

            <div className="pt-5 text-center text-blue-color-primary">
                <div className="py-2">
                    <span>ليس لديك حساب؟</span>
                    <Link
                        to="/auth/signup"
                        className="px-2 text-mint-green-color-primary"
                    >
                        إنشاء حساب
                    </Link>
                </div>
            </div>
        </AuthLayout>
    );
}

export default LoginForm;
